import { render, staticRenderFns } from "./LibraryLandingPageSettings.vue?vue&type=template&id=2a503508&scoped=true&"
import script from "./LibraryLandingPageSettings.vue?vue&type=script&lang=js&"
export * from "./LibraryLandingPageSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a503508",
  null
  
)

export default component.exports